import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
:root,
:host {
  --size-base-unit: 0.5rem;
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to right" or "to left" need to be switched to using deg values
 * 3) Background Position From is used for reversing animation from right to left at 0%
 * 4) Background Position To is used for reversing animation from right to left at 100%
 * 5) Rotate Icon to 180deg for nav button
 * 6) Transformation size for badge left positions
 * 7) Transformation size for badge right positions
 * 8 to 18) Padding values for Input Field Type Tel
 */
[dir=rtl] {
  --rtlTranslateX: 50%; /* 1 */
  --rtlGradientToRight: 270deg; /* 2 */
  --rtlBackgroundPositionFrom: -135%; /* 3 */
  --rtlBackgroundPositionTo: 0%; /* 4 */
  --rtlRotate180: 180deg; /* 5 */
  --rtlRotate135: 135deg;
  --rtlBadgeLeft: -1.5; /* 6 */
  --rtlBadgeRight: 1.5; /* 7 */
  --rtlTelTypeInputFieldPaddingStart: calc(var(--size-base-unit) * 5); /* 8 */
  --rtlTelTypeInputFieldPaddingEnd: calc(var(--size-base-unit) * 2); /* 9 */
  --rtlTelTypeInputFieldMedPaddingStart: calc(var(--size-base-unit) * 4.5); /* 10 */
  --rtlTelTypeInputFieldMedPaddingEnd: calc(var(--size-base-unit) * 1.5); /* 11 */
  --rtlTelTypeInputFieldSmPaddingStart: calc(var(--size-base-unit) * 4); /* 12 */
  --rtlTelTypeInputFieldSmPaddingEnd: calc(var(--size-base-unit) * 1); /* 13 */
  --rtlTelTypeInputFieldCharBeforePaddingEnd: calc(var(--size-base-unit) * 3.75); /* 14 */
  --rtlTelTypeInputFieldCharAfterPaddingStart: calc(var(--size-base-unit) * 6); /* 15 */
  --rtlTelTypeInputFieldCharAfterErrPaddingStart: calc(var(--size-base-unit) * 9); /* 16 */
  --rtlTelTypeInputFieldIconAfterErrPaddingStart: calc(var(--size-base-unit) * 8); /* 17 */
  --rtlTelTypeInputFieldIconCharAfterErrPaddingStart: calc(var(--size-base-unit) * 12); /* 18 */
  --rtlDisplayNone: none;
  --rtlDisplayBlock: block;
  --rtlDrawerRightTranslateX: -100%;
  --rtlDrawerLeftTranslateX: 100%;
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
/**
 * style for text ellipsis
 */
/**
 * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
 */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
dialog {
  position: unset;
  inset: unset;
  width: unset;
  height: unset;
  margin: unset;
  border: unset;
  padding: unset;
  color: unset;
  background-color: unset;
  overflow: unset;
  all: unset;
}

/* ------------------------------------*\
    #DRAWER
\*------------------------------------ */
/**
 * 1) a large container that enters from the edge of the screen when triggered by a user.
 *    It’s used to provide users with actions and info without interrupting their flow like a modal.
 * 2) The container element is the backdrop that occupies the full viewport width and height.
 *    This allows for ghosting back the backdrop and handling click events outside the drawer
 */
.cat-c-drawer {
  position: fixed;
  inset-block: 0 0;
  inset-inline: 0 0;
  z-index: var(--cat-z-index-500);
  width: 100%;
  height: 100%;
  visibility: hidden;
  opacity: 0;
}
.cat-c-drawer.cat-is-active {
  visibility: visible;
  opacity: 1;
}
.cat-c-drawer.cat-c-side-panel {
  visibility: visible;
  opacity: 1;
  width: 0%;
  height: 0%;
}

/**
 * Right-positioned drawer
   * 1) This makes the show button position to right
*/
.cat-c-drawer.cat-c-drawer--right {
  inset-inline: auto 0;
}

/**
 * Drawer with a dimmed backdrop, similar to a modal background
 */
.cat-c-drawer--backdrop {
  transition: background var(--cat-anim-move-long) var(--cat-anim-ease);
  background: none;
  /**
   * Active drawer with backdrop
   */
}
.cat-c-drawer--backdrop.cat-is-active {
  background: var(--cat-color-dim-60);
}

/**
 * The actual content creator
 */
.cat-c-drawer__panel {
  position: fixed;
  text-align: start;
  width: 100%;
  height: 100%;
  inset-inline-start: 0;
  inset-block-start: 0;
  background-color: var(--cat-theme-color-background-default);
  box-shadow: var(--cat-theme-box-shadow-lg);
  transition: all 0.4s ease;
  transform: translateX(var(--rtlDrawerLeftTranslateX, -100%));
  display: flex;
  flex-direction: column;
  max-width: 100%;
  /**
   * Right-positioned drawer
   * 1) This is the default position
   */
  /**
   * Active left-positioned drawer
   */
  /**
   * Active right-positioned drawer
   */
  /**
   * full WIdth panel for mobile view
   */
}
.cat-c-drawer--size-default .cat-c-drawer__panel {
  width: calc(var(--size-base-unit) * 58);
}
.cat-c-drawer--lg .cat-c-drawer__panel {
  width: calc(var(--size-base-unit) * 87);
}
.cat-c-drawer--right .cat-c-drawer__panel {
  inset-inline: auto 0;
  transform: translateX(var(--rtlDrawerRightTranslateX, 100%));
}
.cat-is-active .cat-c-drawer__panel {
  transform: translateX(0);
  box-shadow: var(--cat-box-shadow-lg);
  outline: none;
}
.cat-c-drawer--right.cat-is-active .cat-c-drawer__panel {
  transform: translateX(0);
}
@media all and (width <= calc(48rem - 0.02px)) {
  .cat-c-drawer .cat-c-drawer__panel {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
  }
}

/**
 * Flip the hide button when active
 */
.cat-is-active .cat-c-drawer__hide-button {
  transform: scaleX(-1);
}

/**
 * Drawer header container
 */
.cat-c-drawer__header {
  padding: calc(var(--size-base-unit) * 2);
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-block-end: 1px solid var(--cat-theme-color-border-default);
  position: relative;
}

.cat-c-drawer__header-actions {
  display: block;
  padding-inline-end: calc(var(--size-base-unit) * 2);
  border-inline-end: 1px solid var(--cat-theme-color-border-default);
}

/**
 * Drawer header content
 */
.cat-c-drawer__header-content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-basis: 100%;
}

/**
 * Option hide/show button
 */
.cat-c-drawer__hide-button {
  position: absolute;
  inset-block-start: 0;
  z-index: var(--cat-z-index-100);
  /**
   * Pass down button style updates
   */
  --cat-theme-border-radius: 0;
  --cat-theme-button-width: calc(var(--size-base-unit) * 2.5);
  --cat-button-padding: calc(var(--size-base-unit) * 2.5) 0;
  /**
   * Left aligned
   */
  /**
   * Right aligned
   */
}
.cat-c-drawer__hide-button--left {
  inset-inline-start: calc(var(--size-base-unit) * -2.5);
}
.cat-c-drawer__hide-button--right {
  inset-inline-end: calc(var(--size-base-unit) * -2.5);
}

/**
 * Drawer body container
 * 1) Flex contents to span the available space
 */
.cat-c-drawer__body {
  padding: var(--cat-c-drawer-body-padding, calc(var(--size-base-unit) * 2));
  flex: 1;
  overflow: auto;
}

/**
 * Drawer footer container
 */
.cat-c-drawer__footer {
  padding: calc(var(--size-base-unit) * 2);
  border-block-start: 1px solid var(--cat-theme-color-border-default);
}
.cat-c-drawer--center .cat-c-drawer__footer {
  display: flex;
  justify-content: center;
}

/**
 * Drawer close button
 * The button that appears after the heading
 */
.cat-c-drawer__close-button {
  margin-inline-start: calc(var(--size-base-unit) * 3);
}

.cat-c-drawer--bottom-wrapper {
  display: flex;
  flex-direction: column;
  overflow: auto;
  flex: 1 1 0%;
}

/**
 * Drawer Orientation Bottom
 * Drawer style in mobile view
 */
@media all and (width <= calc(48rem - 0.02px)) {
  .cat-c-drawer--orientation-bottom .cat-c-drawer__panel {
    height: auto;
    inset-block: auto 0;
    transform: translate(0, 100%);
    border-radius: var(--cat-border-radius-lg) var(--cat-border-radius-lg) 0 0;
  }
  .cat-c-drawer--orientation-bottom.cat-is-active .cat-c-drawer__panel {
    transform: translate(0, 0);
  }
  .cat-c-drawer--orientation-bottom .cat-c-drawer__body {
    overflow: visible;
  }
}

@media all and (width <= calc(48rem - 0.02px)) {
  .cat-c-drawer--vertical-height-default .cat-c-drawer__panel {
    max-height: 50vh;
  }
}

@media all and (width <= calc(48rem - 0.02px)) {
  .cat-c-drawer--vertical-height-large .cat-c-drawer__panel {
    max-height: 90vh;
  }
}
`;
       